import { n as e } from "./ajvresolver-Cxtdueba.js";
import { t } from "./prepareConfiguration-DbRyekyU.js";
import { n, t as r } from "./ConfigEditorContext-CoIs6lgL.js";
import { t as i } from "./configEditor.translations-DXHXmRwX.js";
import { r as a } from "./PanelHeader-D-Qg1q2l.js";
import { t as o } from "./ErrorIndicatorDot-BJKDPGHu.js";
import { n as s } from "./types-CsIxq0a2.js";
import { t as c } from "./constants-DosvsSYo.js";
import { t as l } from "./advancedModeStore-DjanuFd1.js";
import { a as u, i as d, n as f, o as p, r as m, t as h } from "./routes-AG-jpSs5.js";
import { n as g } from "./useErrorIndicator-CgX9KKji.js";
import { t as _ } from "./useBuildSyncLists-BAwVcEtd.js";
import { t as v } from "./useAnalyticsAvailability-CIyTIZUn.js";
import { Outlet as y, useLocation as b, useNavigate as x } from "@tanstack/react-router";
import { useEffect as S } from "react";
import { FormProvider as C, useForm as w, useFormState as T } from "react-hook-form";
import { Fragment as E, jsx as D, jsxs as O } from "react/jsx-runtime";
import { Breadcrumb as k, Button as A, Checkbox as j, DetailPageLayout as M, Icon as N, NavigationTable as P, StaticTooltipHost as F, TabNavigationLayout as I, Typography as L, cn as R, tokens as z } from "@vintecc/components";
import { faSlider as B, faSliders as V } from "@vintecc/pro-light-svg-icons";
import { faCompassDrafting as H } from "@vintecc/pro-regular-svg-icons";
//#region src/components/ConfigurationFormProvider.tsx
var U = ({ children: r, configuration: a, viewOnly: o }) => {
	let { showTriggers: s, externalSchemas: c } = n(), { t: l } = i();
	return /* @__PURE__ */ D(C, {
		...w({
			defaultValues: t(a ?? {}, s),
			resolver: e(s, c, l),
			reValidateMode: "onBlur",
			mode: "onBlur",
			disabled: o
		}),
		children: r
	});
}, W = () => {
	let { t: e } = i(), t = b(), r = x(), { routeBasePath: a } = n(), o = l((e) => e.isAdvancedMode), s = l((e) => e.toggleAdvancedMode);
	return /* @__PURE__ */ D(F, {
		tooltip: e("configEditor.advancedToggle.tooltip", "Toggle advanced options"),
		place: "top",
		children: /* @__PURE__ */ D(j, {
			name: "checkbox-isadvancedmode",
			"aria-label": e("configEditor.advancedToggle.ariaLabel", "Toggle advanced mode"),
			variant: "toggle-icon",
			size: "large",
			toggleIconOn: /* @__PURE__ */ D(N, {
				icon: V,
				fontSize: 16,
				className: "text-(--theme-default-color)"
			}),
			toggleIconOff: /* @__PURE__ */ D(N, {
				icon: B,
				fontSize: 16,
				className: "text-green-600"
			}),
			checked: o,
			defaultChecked: o,
			onChange: () => {
				let n = c(t.pathname, e).find((e) => t.pathname.includes(`/${e.path}`));
				o && n && n.advanced && r({
					to: a,
					replace: !0
				}), s();
			}
		})
	});
}, G = ({ children: e, className: t }) => /* @__PURE__ */ D("span", {
	className: R("rounded-full px-3 py-1 text-xs bg-blue-100 text-(--theme-default-color) uppercase font-semibold", t),
	children: /* @__PURE__ */ D("p", { children: e })
}), K = ({ configuration: e, isFormDisabled: t }) => {
	let { t: r } = i(), a = !e, { metadata: o, onNavigateToOriginal: s, onPush: c } = n();
	return /* @__PURE__ */ O("div", {
		className: "flex items-center gap-2",
		children: [
			(o?.isInherited ?? !1) && /* @__PURE__ */ O(E, { children: [/* @__PURE__ */ D(G, { children: r("configEditor.configuration.isInherited", "Inherited") }), /* @__PURE__ */ D(F, {
				tooltip: s ? void 0 : r("configEditor.configuration.noAccessToOriginal", "You don't have access to the original configuration"),
				children: /* @__PURE__ */ D(A, {
					onClick: s,
					variant: "outline",
					disabled: !s,
					children: r("configEditor.actions.goToOriginalConfig", "Go to original configuration")
				})
			})] }),
			/* @__PURE__ */ D(W, {}),
			/* @__PURE__ */ D(p, {}),
			!a && !t && c && /* @__PURE__ */ D(d, { configurationId: e.id }),
			!a && /* @__PURE__ */ D(u, {
				configId: e.id,
				isFormDisabled: t
			}),
			!t && /* @__PURE__ */ D(m, {})
		]
	});
}, q = ({ isGreyedOut: e, children: t }) => /* @__PURE__ */ D(L, {
	variant: "h2",
	color: e ? z.color.grey[400] : void 0,
	children: t
}), J = ({ configuration: e, breadcrumbs: t, goBackHref: r, children: a, isCollapsed: u, ...d }) => {
	let { t: p } = i(), m = b(), { hasError: h } = g(), x = !e, { showTriggers: C, routeBasePath: w, breadcrumbs: E } = n(), O = t ?? E, { disabled: A } = T(), { buildAllSyncLists: j } = _(), P = l((e) => e.isAdvancedMode), F = O?.length ? `Go back to ${O[O.length - 1].name}` : "Go to previous page", I = v(), L = C ? c(m.pathname, p) : c(m.pathname, p).filter((e) => e.path !== s.Triggers), R = P ? L : L.filter((e) => !e.advanced), B = p("configEditor.features.analytics.disabledNoInflux", "Analytics requires at least one InfluxDB database configured in Local storage"), V = R.map(({ title: e, path: t, icon: n }) => {
		let r = t === s.Analytics && !I;
		return {
			title: e,
			icon: /* @__PURE__ */ D(o, {
				show: h(t),
				children: /* @__PURE__ */ D(N, {
					icon: n,
					size: "lg"
				})
			}),
			href: `${w}/${t}`,
			replace: !0,
			tooltip: r ? B : u ? e : "",
			disabled: r
		};
	});
	return S(() => {
		A || j();
	}, [A]), /* @__PURE__ */ D(M, {
		...d,
		title: /* @__PURE__ */ D(q, {
			isGreyedOut: !!u,
			children: x ? p("configEditor.configuration.new", "New Configuration") : e?.name || p("configEditor.configuration.title", "Configuration")
		}),
		parent: O ? /* @__PURE__ */ D(k, {
			breadcrumbs: O,
			endSeparator: !0
		}) : void 0,
		customIcon: /* @__PURE__ */ D(N, {
			icon: H,
			size: "xl",
			color: u ? z.color.grey[400] : void 0
		}),
		backButton: r ? /* @__PURE__ */ D(f, {
			fallbackHref: r,
			disabled: u,
			"aria-label": F
		}) : void 0,
		nav: V,
		actions: /* @__PURE__ */ D(K, {
			configuration: e,
			isFormDisabled: A
		}),
		scrollableContent: !0,
		isCollapsed: u,
		children: a ?? /* @__PURE__ */ D(y, {})
	});
}, Y = ({ configuration: e, defaultConfiguration: t, breadcrumbs: r, goBackHref: i, children: o }) => {
	let { readonly: s, metadata: c } = n(), l = b(), u = !e, d = c?.isInherited ?? !1, f = h(l.pathname);
	return S(() => {
		a();
	}, []), /* @__PURE__ */ D(U, {
		configuration: u ? t : e,
		viewOnly: d || s,
		children: /* @__PURE__ */ D(J, {
			configuration: e,
			breadcrumbs: r,
			goBackHref: i,
			isCollapsed: f,
			style: f ? { background: z.color.grey[100] } : void 0,
			children: o
		})
	});
}, X = ({ configuration: e, defaultConfiguration: t, breadcrumbs: n, goBackHref: i, children: a, routeBasePath: o, readonly: s, metadata: c, showTriggers: l, referenceData: u, allVariables: d, onSave: f, onDelete: p, onPush: m, onShowLinkedGateways: h, onNavigateToOriginal: g, externalSchemas: _ }) => /* @__PURE__ */ D(r, {
	routeBasePath: o,
	readonly: s,
	configuration: e,
	metadata: c,
	showTriggers: l,
	referenceData: u,
	allVariables: d,
	onSave: f,
	onDelete: p,
	onPush: m,
	onShowLinkedGateways: h,
	onNavigateToOriginal: g,
	breadcrumbs: n,
	externalSchemas: _,
	children: /* @__PURE__ */ D(Y, {
		configuration: e,
		defaultConfiguration: t,
		breadcrumbs: n,
		goBackHref: i,
		children: a
	})
});
//#endregion
export { K as a, I as i, J as n, W as o, P as r, X as t };

//# sourceMappingURL=ConfigurationDetail-D_i_kbRs.js.map